// extracted by mini-css-extract-plugin
module.exports = {"logoContainer":"metamask-button_logoContainer__02HpU","children":"metamask-button_children__VwIyy"};